<div class="map-tune-panel" [@slideInOut]="slideState" [style.z-index]="zIndex" [hidden]="loadingMap" fxLayout="column"
    fxLayoutGap="1.5vh" style="overflow-y: auto; overflow-x: hidden; scrollbar-color: #ffffff transparent;">
    <div fxFlex fxGrow="0" class="hide-filters-icon" fxLayoutAlign="end center">
        <mat-icon [matTooltip]="'Hide Tune' | translate" (click)="closed.emit()">close</mat-icon>
    </div>
    <div fxFlex fxLayout="column" fxLayoutGap="1.2vh" fxGrow="0" style="margin-top: 1.5vh;">
        <div fxFlex fxGrow="0" class="options-container" style="margin-left: 0;" *ngIf="hasIconControls()">
            <div class="section-title">{{'Icon Size' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="allIconScalePercent" (ngModelChange)="onAllIconScalePreview($event)"
                    (dragEnd)="applyAllIconScales()" (change)="applyAllIconScales()">
            </mat-slider>
        </div>

        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasNotes()">
            <mat-icon>note</mat-icon>
            <div>{{'Notes' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="noteIconScalePercent"
                    (ngModelChange)="noteIconScalePercentChange.emit($event)">
            </mat-slider>
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasLocations()">
            <mat-icon><img src="assets/images/icon/move_location_white.svg" style="width: 20px;" /></mat-icon>
            <div>{{'Go to Location' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="locationIconScalePercent"
                    (ngModelChange)="locationIconScalePercentChange.emit($event)">
            </mat-slider>
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasAnnotations()">
            <mat-icon>draw</mat-icon>
            <div>{{'Annotation' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="annotationIconScalePercent"
                    (ngModelChange)="annotationIconScalePercentChange.emit($event)">
            </mat-slider>
        </div>
        <div *ngIf="hasCarOfInterest() || hasPersonOfInterest()" class="divider-line">
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasCarOfInterest()">
            <mat-icon>directions_car</mat-icon>
            <div>{{'Car of Interest' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="carOfInterestIconScalePercent"
                    (ngModelChange)="carOfInterestIconScalePercentChange.emit($event)">
            </mat-slider>
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasPersonOfInterest()">
            <mat-icon>person_pin_circle</mat-icon>
            <div>{{'Person of Interest' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="personOfInterestIconScalePercent"
                    (ngModelChange)="personOfInterestIconScalePercentChange.emit($event)">
            </mat-slider>
        </div>
        <div *ngIf="hasThreats()" class="divider-line">
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasThreats()">
            <mat-icon>warning</mat-icon>
            <div>{{'Incident' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="threatIconScalePercent"
                    (ngModelChange)="threatIconScalePercentChange.emit($event)">
            </mat-slider>
        </div>
        <div *ngIf="hasMarkerType('investigator') || hasMarkerType('investigator-group') || hasCustomPins()"
            class="divider-line">
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasMarkerType('investigator')">
            <mat-icon>local_police</mat-icon>
            <div>{{'Investigators' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="investigatorIconScalePercent"
                    (ngModelChange)="investigatorIconScalePercentChange.emit($event)">
            </mat-slider>
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasMarkerType('investigator-group')">
            <mat-icon>workspaces</mat-icon>
            <div>{{'Groups' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="investigatorGroupIconScalePercent"
                    (ngModelChange)="investigatorGroupIconScalePercentChange.emit($event)">
            </mat-slider>
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasCustomPins()">
            <mat-icon>pin_drop</mat-icon>
            <div>{{'Drag & Drop Pins' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="customMarkerIconScalePercent"
                    (ngModelChange)="customMarkerIconScalePercentChange.emit($event)">
            </mat-slider>
        </div>
        <div *ngIf="hasMarkerType('camera')" class="divider-line">
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasMarkerType('camera')">
            <mat-icon>videocam</mat-icon>
            <div>{{'Cameras' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="cameraIconScalePercent"
                    (ngModelChange)="cameraIconScalePercentChange.emit($event)">
            </mat-slider>
        </div>
        <div *ngIf="hasMarkerType('building') && enableSiteMapping" class="divider-line">
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasMarkerType('building') && enableSiteMapping">
            <mat-icon>apartment</mat-icon>
            <div>{{'Sites' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="buildingIconScalePercent"
                    (ngModelChange)="buildingIconScalePercentChange.emit($event)">
            </mat-slider>
        </div>
        <!-- <div *ngIf="hasOpacityControls()" style="border-top: 1px solid rgba(255,255,255,0.12); margin-bottom: 3vh;">
        </div> -->
        <span *ngIf="hasOpacityControls()" fxFlex fxGrow="0" class="section-title" style="margin-top: 2vh;">{{'Opacity'
            |
            translate}}</span>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasMarkerType('camera')">
            <mat-icon>vrpano</mat-icon>
            <div>{{'Camera Field of View' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="cameraSectorOpacityPercent"
                    (ngModelChange)="cameraSectorOpacityPercentChange.emit($event)">
            </mat-slider>
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasBaseStationData">
            <mat-icon>signal_wifi_4_bar</mat-icon>
            <div>{{'Base Station Location' | translate}}</div>
            <mat-slider min="0" max="100" step="5">
                <input matSliderThumb [ngModel]="baseStationSectorOpacityPercent"
                    (ngModelChange)="baseStationSectorOpacityPercentChange.emit($event)">
            </mat-slider>
        </div>

        <!-- <div style="border-top: 1px solid rgba(255,255,255,0.12); margin-bottom: 3vh;"></div> -->
        <span fxFlex fxGrow="0" class="section-title" style="margin-top: 2vh;">{{'Filters' |
            translate}}</span>
        <div fxFlex fxGrow="0" class="options-container">
            <mat-icon>info</mat-icon>
            <div>{{'Tooltips' | translate}}</div>
            <mat-slide-toggle [ngModel]="isTooltipOn"
                (ngModelChange)="isTooltipOnChange.emit($event)"></mat-slide-toggle>
        </div>
        <div fxFlex fxGrow="0" class="options-container">
            <mat-icon>label</mat-icon>
            <div>{{'Icon Labels' | translate}}</div>
            <mat-slide-toggle [ngModel]="isIconLabelsOn"
                (ngModelChange)="isIconLabelsOnChange.emit($event)"></mat-slide-toggle>
        </div>
        <div fxFlex fxGrow="0" class="options-container" *ngIf="hasMarkerType('building') && enableSiteMapping">
            <mat-icon>apartment</mat-icon>
            <div>{{'Site icons' | translate}}</div>
            <mat-slide-toggle [ngModel]="isBuildingIconsFilterOn"
                (ngModelChange)="isBuildingIconsFilterOnChange.emit($event)"></mat-slide-toggle>
        </div>
    </div>
</div>